import * as WebViewBridge from '@/checkout-instore-legacy/utils/WebViewBridge'
import Scroll from '@/checkout-instore-legacy/utils/Scroll'
import { resourceIsAvailable } from '@/checkout-instore-legacy/device/utils'

let element
let onPullToRefresh
let scrollListener

export function listen(_element, _onPullToRefresh) {
  if (!isAvailable()) {
    throw new Error('Pull to refresh is unavailable in this device')
  }

  element = _element
  onPullToRefresh = _onPullToRefresh

  WebViewBridge.listen(onReceiveWebViewBridgeEvent)

  scrollListener = new Scroll(element)
  scrollListener.listen(onScrollTopChange)

  if (scrollListener.isScrollOnTop()) {
    enableNativeFeature()
  }
}

export function unlisten() {
  disableNativeFeature()
  WebViewBridge.unlisten(onReceiveWebViewBridgeEvent)

  scrollListener && scrollListener.unlisten()
  scrollListener = null

  element = null
  onPullToRefresh = null
}

export function stopLoading() {
  if (isAvailable()) {
    WebViewBridge.sendEvent({
      type: 'finishRefreshingPullToRefresh',
    })
  }
}

export function isAvailable() {
  return resourceIsAvailable('pullToRefresh')
}

export function enableNativeFeature() {
  WebViewBridge.sendEvent({
    type: 'enablePullToRefresh',
  })
}

export function disableNativeFeature() {
  WebViewBridge.sendEvent({
    type: 'disablePullToRefresh',
  })
}

function onReceiveWebViewBridgeEvent(event) {
  if (event.type === 'pullToRefresh') {
    onPullToRefresh && onPullToRefresh()
  }
}

function onScrollTopChange() {
  if (scrollListener.isScrollOnTop()) {
    enableNativeFeature()
  } else {
    disableNativeFeature()
  }
}
